(() => {
  const landing = document.querySelector('[data-up-date-landing]');
  if (!landing) return;
  const root = document;

  const variants = JSON.parse(landing.querySelector('[data-up-date-variants]')?.textContent || '[]');
  let selectedVariantId = landing.querySelector('.product-variant-id')?.value || variants[0]?.id;
  let pendingAdd = null;

  const pushCommerceEvent = (event, details = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, product_name: 'Up-Date Auto Swiper', ...details });
  };

  const currentVariant = () => variants.find((item) => String(item.id) === String(selectedVariantId));
  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  };

  const updateVariant = (id) => {
    const variant = variants.find((item) => String(item.id) === String(id));
    if (!variant) return;
    selectedVariantId = variant.id;
    root.querySelectorAll('.product-variant-id').forEach((input) => { input.value = variant.id; input.disabled = false; });
    root.querySelectorAll('[data-up-date-price]').forEach((node) => { node.textContent = formatMoney(variant.price); });
    root.querySelectorAll('[data-up-date-atc]').forEach((button) => {
      button.disabled = !variant.available;
      const label = button.querySelector('[data-up-date-atc-label]');
      if (!label) return;
      const base = button.dataset.shortLabel || 'Get Up-Date';
      label.textContent = variant.available ? `${base} — ${formatMoney(variant.price)}` : 'Sold out';
    });
  };

  root.querySelectorAll('[data-up-date-variant-select]').forEach((select) => {
    select.addEventListener('change', () => updateVariant(select.value));
  });

  root.querySelectorAll('[data-up-date-quantity]').forEach((input) => {
    input.addEventListener('input', () => {
      const quantity = Math.max(1, Number.parseInt(input.value, 10) || 1);
      root.querySelectorAll('.up-date-product-form input[name="quantity"]').forEach((field) => { field.value = quantity; });
    });
  });

  if (!window.__upDateViewContentTracked) {
    const variant = currentVariant();
    pushCommerceEvent('ViewContent', {
      content_ids: variant ? [String(variant.id)] : [],
      content_type: 'product',
      product_id: variant ? String(variant.id) : undefined,
      variant_id: variant?.id,
      value: variant ? variant.price / 100 : undefined,
      currency: window.Shopify?.currency?.active || 'USD',
    });
    window.__upDateViewContentTracked = true;
  }

  root.querySelectorAll('.up-date-product-form form').forEach((form) => {
    form.addEventListener('submit', () => {
      const button = form.querySelector('[data-up-date-atc]');
      const variant = variants.find((item) => String(item.id) === String(form.querySelector('[name="id"]')?.value));
      pendingAdd = {
        cta_location: button?.dataset.ctaLocation || 'unknown',
        content_ids: variant ? [String(variant.id)] : [],
        content_type: 'product',
        product_id: variant ? String(variant.id) : undefined,
        variant_id: variant?.id,
        value: variant ? variant.price / 100 : undefined,
        currency: window.Shopify?.currency?.active || 'USD',
        quantity: Number.parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1,
      };
    });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, ({ productVariantId }) => {
      if (!pendingAdd || String(pendingAdd.variant_id) !== String(productVariantId)) return;
      pushCommerceEvent('AddToCart', pendingAdd);
      pendingAdd = null;
    });
  }

  document.addEventListener('click', (event) => {
    const control = event.target.closest('button[name="checkout"], a[href*="/checkout"]');
    if (!control || control.dataset.upDateCheckoutTracked === 'true') return;
    control.dataset.upDateCheckoutTracked = 'true';
    const variant = currentVariant();
    pushCommerceEvent('InitiateCheckout', {
      content_ids: variant ? [String(variant.id)] : [],
      content_type: 'product',
      product_id: variant ? String(variant.id) : undefined,
      variant_id: variant?.id,
      value: variant ? variant.price / 100 : undefined,
      currency: window.Shopify?.currency?.active || 'USD',
    });
  });

  root.querySelectorAll('[data-up-date-scroll-buy]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector('#up-date-purchase');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    });
  });

  document.querySelectorAll('header a').forEach((link) => {
    if (link.textContent.trim().toLowerCase() !== 'buy now') return;
    link.addEventListener('click', (event) => {
      const target = document.querySelector('#up-date-purchase');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    });
  });

  root.querySelectorAll('[data-up-date-accordion]').forEach((button) => {
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      if (matchMedia('(max-width: 749px)').matches) {
        root.querySelectorAll('[data-up-date-accordion][aria-expanded="true"]').forEach((other) => {
          if (other === button) return;
          other.setAttribute('aria-expanded', 'false');
          document.getElementById(other.getAttribute('aria-controls'))?.setAttribute('hidden', '');
        });
      }
      button.setAttribute('aria-expanded', String(!expanded));
      document.getElementById(button.getAttribute('aria-controls'))?.toggleAttribute('hidden', expanded);
    });
  });

  const heroButton = root.querySelector('[data-cta-location="hero"]');
  const sticky = root.querySelector('[data-up-date-sticky]');
  if (heroButton && sticky && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
    observer.observe(heroButton);
    const footer = document.querySelector('footer');
    if (footer) new IntersectionObserver(([entry]) => sticky.classList.toggle('is-footer-visible', entry.isIntersecting)).observe(footer);
  }
})();
